import React from "react";
import { Reveal } from "./Reveal";
const pains = [{
  emoji: "😰",
  text: "Siempre has querido vender sales de baño, pero no sabes cuál debería ser el primer paso."
}, {
  emoji: "🤯",
  text: "Has visto emprendimientos en Instagram y piensas: “Yo también quisiera tener una marca así.” Pero no sabes cómo hacerlo realidad."
}, {
  emoji: "🌸",
  text: "Te emociona la idea de crear una colección propia… pero no sabes qué necesitas para empezar."
}, {
  emoji: "💸",
  text: "Piensas que necesitas mucha experiencia, cursos costosos o invertir miles de dólares para lanzar una marca."
}, {
  emoji: "😓",
  text: "Tienes miedo de perder tiempo comprando materiales que quizá ni siquiera necesitas."
}, {
  emoji: "❤️",
  text: "Sueñas con ver una colección de sales de baño con TU nombre en la etiqueta."
}];
export function PainPoints() {
  return <section className="w-full bg-white px-5 py-14" data-id="element-171" data-mp="3nbcz4gul6qrv">
      <div className="mx-auto max-w-xl" data-id="element-172" data-mp="1z0orgnycznep">
        <Reveal className="text-center" data-id="element-173" data-mp="1yzn6nrrjjmjs">
          <h2 className="font-serif-display text-2xl font-semibold leading-snug text-[#3d2b30] sm:text-3xl" data-id="element-174" data-mp="1yybzrj2styog">
            💭 ¿Te identificas con alguna de estas situaciones?
          </h2>
          <p className="mt-3 text-sm text-[#6b565b] sm:text-base" data-id="element-175" data-mp="27v34skzbwnv6">
            Si respondes “Sí” a una de ellas… este Kit fue creado para ti.
          </p>
        </Reveal>

        <div className="mt-8 space-y-3" data-id="element-176" data-mp="1g2lyxz6lr8c5">
          {pains.map((p, i) => <Reveal key={i} delay={i * 0.04} data-id="element-177" data-mp="1b3hpd7frn8la" data-mpi={i}>
              <div className="flex items-start gap-3 rounded-2xl border border-[#f0e0e4] bg-[#fbf5f0] p-4" data-id="element-178" data-mp="1b4ssr65auebv">
                <span className="text-2xl leading-none" data-id="element-179" data-mp="1p04mba7pxyr7">{p.emoji}</span>
                <p className="text-sm leading-relaxed text-[#4d3a3f]" data-id="element-180" data-mp="1k1urj0pwp064">{p.text}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} className="mt-8 text-center" data-id="element-181" data-mp="2viteimtkphg7">
          <p className="font-serif-display text-lg italic text-[#a04a63]" data-id="element-182" data-mp="2vibav54l00y9">
            Tú también puedes vivir ese momento…
          </p>
        </Reveal>
      </div>
    </section>;
}